var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgAdOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.907563C0 0.40633 0.40633 0 0.907563 0H23.0924C23.5937 0 24 0.40633 24 0.907563C24 1.4088 23.5937 1.81513 23.0924 1.81513H0.907563C0.40633 1.81513 0 1.4088 0 0.907563Z",
    fill: "var(--primary-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.0924C0 16.5912 0.40633 16.1849 0.907563 16.1849H23.0924C23.5937 16.1849 24 16.5912 24 17.0924C24 17.5937 23.5937 18 23.0924 18H0.907563C0.40633 18 0 17.5937 0 17.0924Z",
    fill: "var(--primary-6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92437 7.96639C2.92437 6.29561 4.2788 4.94118 5.94958 4.94118H18.0504C19.7212 4.94118 21.0756 6.29561 21.0756 7.96639V9.98319C21.0756 11.654 19.7212 13.0084 18.0504 13.0084H5.94958C4.2788 13.0084 2.92437 11.654 2.92437 9.98319V7.96639ZM5.94958 6.7563H18.0504C18.7187 6.7563 19.2605 7.29808 19.2605 7.96639V9.98319C19.2605 10.6515 18.7187 11.1933 18.0504 11.1933H5.94958C5.28127 11.1933 4.7395 10.6515 4.7395 9.98319V7.96639C4.7395 7.29808 5.28127 6.7563 5.94958 6.7563Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdOutlined);
export default __webpack_public_path__ + "static/media/adOutlined.9be80aeed843efa3480f9e5762717036.svg";
export { ForwardRef as ReactComponent };